import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PlayersListSection from './PlayersListSection';
import PlayersListEmptyState from './PlayersListEmptyState';
import CreatePlayerOnTheGo from './../CreatePlayerOnTheGo';
import BottomButtonBar from '../../../../components/BottomButtonBar';
import {CreateGameFormPropTypes, createUserInfoPropType, PlayerMinimalPropType, NavbarSearchPropTypes}
    from "../../../../utils/propTypes";

export default class PlayersList extends Component {
    getMainSectionTitle() {
        if (this.searchIsActive()) {
            return 'search results';
        } else if (this.props.createNewUserForm.showForm) {
            return 'create new user';
        }
        return 'Suggestions';
    }

    getMainSectionPlayers() {
        if (this.searchIsActive()) {
            // Filter out players who are already active
            return this.props.search.players.filter(p => this.props.form.activePlayers.indexOf(p.id) === -1);
        }
        return this.props.players.filter(p => !p.selected);
    }

    searchIsActive() {
        return (this.props.search.isOpen && this.props.search.query.length);
    }

    renderCreatePlayersOnTheGo() {
        return (<CreatePlayerOnTheGo
            initialInput={this.props.search.query}
            createUser={this.props.createUser}
            createNewUserForm={this.props.createNewUserForm}
            onCancel={this.props.clearSearch}
        />);
    }

    renderEmptyState() {
        if (this.props.createNewUserForm.showForm) {
            return null;
        }
        // If the search didn't have any matches, then instead of showing an empty state message, we actually
        // render the CreatePlayersOnTheGo
        if (this.searchIsActive()) {
            return this.renderCreatePlayersOnTheGo();
        }

        // If the search isn't active, then it means that the user hasn't played any games with other players
        // and we can't show any suggestions
        const message = "I don't have  any suggestions for you. Use the search to look for existing " +
            "players or tap the '+' icon to create new accounts for your friends";
        return <PlayersListEmptyState message={message} />;
    }

    render() {
        const hasActivePlayers = this.props.form.activePlayers.length;
        let activePlayersComponent = null;

        // Display CreatePlayerOnTheGo when shoForm is true AND the search isn't active.
        let createPlayersOnTheGo = null;
        if (this.props.createNewUserForm.showForm && !this.searchIsActive()) {
            createPlayersOnTheGo = (<CreatePlayerOnTheGo
                initialInput={this.props.search.query}
                createUser={this.props.createUser}
                createNewUserForm={this.props.createNewUserForm}
                onCancel={this.props.onCreateNewUserFormHideForm}
            />);
        }

        // Display the 'SELECTED PLAYERS' section, when we have active players and the search isn't open
        // and the CreatePlayerOnTheGo isn't open
        if (hasActivePlayers && !this.searchIsActive() && !this.props.createNewUserForm.showForm) {
            activePlayersComponent = (<PlayersListSection
                title="selected players"
                players={this.props.players.filter(p => p.selected)}
                selectPlayer={this.props.selectPlayer}
                leftIcon="fa fa-check"
            />);
        }

        const players = this.getMainSectionPlayers();
        // If we don't have any players in the main section ( suggestions / search results), then show empty state
        let emptyState = null;
        if (players.length === 0) {
            emptyState = this.renderEmptyState(players);
        }

        // Show the players suggestions only when the CreatePlayerOnTheGo isn't visible
        let playerSuggestions = players;
        if (this.props.createNewUserForm.showForm) {
            playerSuggestions = [];
        }

        // Show the CLOSE icon on the titlebar only when the CreateNewUserForm is open.
        let titleBarRightIcon = null;
        if (this.props.createNewUserForm.showForm) {
            titleBarRightIcon = "fa fa-times";
        }

        const playerSuggestionsComponent = (<PlayersListSection
            title={this.getMainSectionTitle()}
            players={playerSuggestions}
            selectPlayer={this.props.selectPlayer}
            extraClasses="players__separator--dark"
            titleBarRightIcon={titleBarRightIcon}
            onRightIconClick={this.props.onCreateNewUserFormHideForm}
        />);

        let bottomButtonBar = null;
        /*
        Show the bottom button bar in the following cases:
        - The CreateNewForm isn't open AND
          - the search isn't active OR
          - the search is active and we have results

        Otherwise the CreatePlayerOnTheGo is rendered and it has it's own bottom button bar.
         */
        if (!this.props.createNewUserForm.showForm &&
            (!this.searchIsActive() || (this.searchIsActive() && players.length > 0))
        ) {
            bottomButtonBar = (<BottomButtonBar
                goBack={this.props.goBack}
                startGame={this.props.startGame}
                disableStartingGame={this.props.disableStartingGame}
                form={this.props.form}
            />);
        }

        return (
            <div>
                <div className="players-list">
                    {activePlayersComponent}
                    {playerSuggestionsComponent}
                    {emptyState}
                    {createPlayersOnTheGo}
                </div>
                {bottomButtonBar}
            </div>
        );
    }
}

PlayersList.propTypes = {
    goBack: PropTypes.func.isRequired,
    disableStartingGame: PropTypes.bool.isRequired,
    selectPlayer: PropTypes.func.isRequired,
    createUser: PropTypes.func.isRequired,
    startGame: PropTypes.func.isRequired,
    clearSearch: PropTypes.func.isRequired,
    onCreateNewUserFormHideForm: PropTypes.func.isRequired,
    players: PropTypes.arrayOf(PlayerMinimalPropType),
    form: CreateGameFormPropTypes,
    search: NavbarSearchPropTypes,
    createNewUserForm: createUserInfoPropType,
};



// WEBPACK FOOTER //
// ./src/apps/create_game/components/Player/PlayersList.js